import { useState, useEffect } from "react";
import { AiOutlineCalendar } from "react-icons/ai";
import Calendar from "react-calendar";
import { currencyPipe, datePipe } from "../../Utils/pipes";
import { useSelector, useDispatch } from "react-redux";
import { cartActions } from "../../store/cart";
import useUser from "../../Context/hook/useUser";
import loadingGift from '../../Assets/img/loadingGift.gif'
import loadingGiftt from '../../Assets/img/loadingGiftt.gif'

function Market({ park, id ,imageFilter}) {
  const ticketsQuantity = useSelector((state) => state.cart.ticketsQuantity);
  const limit = useSelector((state) => state.cart.ticketsLimit);
  const showWarning = useSelector((state) => state.cart.showWarning);
  const warningMessage = useSelector((state) => state.cart.warningMessage.text);
  const fare = useSelector((state) => state.cart.fare);

  const dispatch = useDispatch();
  const { getUser } = useUser();

  useEffect(() => {
    const user = getUser();
    dispatch(cartActions.setDefaults({ user: user, park: park }));
  }, []);

  const [isCalendarVisible, setCalendarVisible] = useState(false);
  const [date, setDate] = useState(new Date());
  const addDays = (date, number) => {
    const newDate = new Date(date);
    return new Date(newDate.setDate(newDate.getDate() + number));
  };
  const today = new Date() + 1;
  const maxDate = addDays(today, 7);
  const handleClick = () => {
    setCalendarVisible((value) => !value);
  };

  const addToCart = () => {
    const item = {
      cantidad: ticketsQuantity,
      fechaValid: datePipe(date),
    };
    dispatch(cartActions.addToCart({ item: item }));
  };
  const isLoadingImage = !imageFilter || imageFilter.length === 0;
  const imageToShow = isLoadingImage
  ? loadingGiftt
  : imageFilter.imagenPerfil || loadingGiftt;
  return (
    <div className="border border-bd-light border-solid basis-auto tab-land:basis-5/12 small-desktop:basis-4/12 p-8 tab-land:p-px rounded-2xl">
      <div className="p-6">
        <div className="border-b border-bd-light border-solid carbonads p-10 mx-auto pb-12 mb-10">
          <div className="flex flex-col justify-center items-center phone:flex-row phone:justify-start phone:items-start">
            <div className="">
              <img
                src={imageToShow}
                alt={park?.nombre}
                className="max-w-[20rem] phone:max-w-[150px]"
              />
            </div>
            <div className="ml-[3rem] mt-6 tab-port:mt-2">
              <p className="text-xl">Parque Nacional</p>
              <p className="text-2xl font-bold pb-2.5">{park?.nombre}</p>
              <p className="text-base ">{park?.description3}</p>
            </div>
          </div>
        </div>
        <div className="relative flex justify-between flex-row ">
          <p className="text-3xl font-bold">Fecha</p>
          <button
            className="float-right text-dark hover:text-primary-light"
            onClick={handleClick}
          >
            <AiOutlineCalendar className="icono" />
          </button>
          {isCalendarVisible && (
            <div className="absolute z-30 top-[3rem] right-0">
              <Calendar
                onChange={(e) => {
                  setDate(e);
                  handleClick();
                }}
                minDate={new Date()}
                maxDate={maxDate}
                value={date}
              />
            </div>
          )}
        </div>
        <div className="mt-7">
          <span className="text-3xl">{datePipe(date)}</span>
        </div>
        <p className="text-3xl font-bold mt-9">Cantidad de tickets</p>
        <div className="select-container flex flex-row mt-4">
          <input
            id="tickets"
            type="number"
            className="select"
            onChange={(e) => {
              dispatch(cartActions.ticketChange({ quantity: +e.target.value }));
            }}
            defaultValue={1}
            min={1}
            max={limit}
          ></input>
          {showWarning ? (
            <p className="warning ml-2 my-auto text-[#ff5356] text-xl font-extrabold">
              {warningMessage}
            </p>
          ) : (
            <p className="font-bold text-xl my-auto ml-2">Tickets</p>
          )}
        </div>
        <div className="flex mt-9 justify-between">
          <p className="text-3xl inline font-bold">Sub-Total:</p>
          <p className="text-3xl inline">
            ${currencyPipe(ticketsQuantity * fare)}
          </p>
        </div>
        <input
          disabled={ticketsQuantity <= 0}
          onClick={addToCart}
          type="submit"
          value="Agregar"
          className="w-full mt-6 cursor-pointer py-4 px-12 text-2xl bg-[#71717a] text-white rounded-lg hover:bg-primary disabled:bg-font-disabled"
        />
      </div>
    </div>
  );
}

export { Market };
